<template>
  <div>
    <div
      v-for="(agreement, agreementIndex) in modifiedAgreements"
      :key="`agreement-history-agreement-${agreementIndex}`"
      class="pb-5 pl-3"
      :data-qa="`agreement-history-agreement-${agreementIndex}`">
      <div
        v-if="mode==='big' && agreement.endAgree"
        class="font-size-12 ml-1 grey--text"
        :data-qa="`agrement-history-agreement-${agreementIndex}-date`">
        {{ $d(new Date(agreement.endAgree), "shortDate") }}, {{ $d(new Date(agreement.endAgree), "time") }}
      </div>
      <div class="flex flex-wrap text-left mb-2">
        <UserIcon
          :data-qa="`agrement-history-agreement-${agreementIndex}-userIcon`"
          :name="agreement.userInfo ? agreement.userInfo.name : '-'"
          size="32"/>
        <div class="ml-1">
          <div
            v-if="mode !== 'big'"
            class="bold font-size-14"
            :data-qa="`agrement-history-agreement-${agreementIndex}-userName`">
            {{ agreement.userInfo ? agreement.userInfo.name : '-' }}
          </div>
          <div
            class="flex"
            :class="{'height-100': mode === 'big'}">
            <div
              v-if="mode === 'big'"
              class="bold font-size-14 mr-2 my-auto"
              :data-qa="`agrement-history-agreement-${agreementIndex}-userName`">
              {{ agreement.userInfo ? agreement.userInfo.name : '-' }}
            </div>
            <StatusChip
              v-if="agreement.status"
              class="font-size-12 px-2 my-auto"
              :data-qa="`agrement-history-agreement-${agreementIndex}-status`"
              :name="agreement.statusTitle"
              :status="agreement.status"/>
            <template v-if="mode !== 'big'">
              <div
                v-if="agreement.endAgree"
                class="font-size-12 ml-1 grey--text"
                :data-qa="`agrement-history-agreement-${agreementIndex}-date`">
                {{ $d(new Date(agreement.endAgree), "shortDate") }}, {{ $d(new Date(agreement.endAgree), "time") }}
              </div>
            </template>
          </div>
        </div>
      </div>
      <div
        v-if="agreement.comment"
        class="agrement-history_comment"
        :data-qa="`agrement-history-agreement-${agreementIndex}-comment`">
        {{ agreement.comment }}
      </div>
      <DocumentList
        :attachments="agreement.files"
        class="agrement-history_documents"
        :new-endpoints="true"
        small/>
    </div>
  </div>
</template>
<script>
import { StorageFile } from '@/types/commonFile.js'

import UserIcon from 'components/header/UserIcon.vue'
import StatusChip from 'components/common/elements/StatusChip.vue'
import DocumentList from 'components/common/blocks/DocumentList.vue'

export default {
  name: 'AgreementsHistoryItems',
  data() {
    return {
      /*files: [
        {
          key: 1,
          title: 'Договір_№1.png',
          size: 2048000
        },
        {
          key: 2,
          title: 'Додаток_№1.pdf',
          size: 1024000
        }
      ]*/
    }
  },
  computed: {
    modifiedAgreements() {
      return this.value.map((agreement) => {
        const files = agreement.files || /*this.files ||*/ []
        return {
          ...agreement,
          files: files.map(file => new StorageFile(null, file, null))
        }
      })
    }
  },
  props: {
    value: {
      type: Array
    },
    mode: {
      type: String,
      validator: function (value) {
        return ['small', 'big'].indexOf(value) !== -1
      },
      default: 'small'
    },
  },
  components: {
    UserIcon,
    StatusChip,
    DocumentList,
  }
}
</script>
<style scoped lang="scss">
.agrement-history {
  &_comment {
    padding: 15px;
    white-space: pre-line;
    text-align: left;
    margin-left: 35px;
    background: var(--color-main-green);
    border-radius: 0 10px 10px 10px;
  }
  &_documents {
    margin-top: 10px;
    margin-left: 35px;
  }
}
</style>
